const shortcuts = [{
        label: 'Italy 🇮🇹',
        notification: 'https://www.icloud.com/shortcuts/9af3730fe37d4a698942a6dde6ce63a2',
        alert: 'https://www.icloud.com/shortcuts/0c225414a7bf430eb28ab6832af9bf11'
    },
    {
        label: 'France 🇫🇷',
        notification: 'https://www.icloud.com/shortcuts/006d75be462946afb6f5169784698712',
        alert: 'https://www.icloud.com/shortcuts/c2eca581510f4cc19c0adaac88e6bb2d'
    },
    {
        label: 'USA 🇺🇸',
        notification: 'https://www.icloud.com/shortcuts/ea139d37a6f5419cae9715bec2b1f8e3',
        alert: 'https://www.icloud.com/shortcuts/4e4ae622b34a4891a5aac82f8d632457'
    },
    {
        label: 'Spain 🇪🇸',
        notification: 'https://www.icloud.com/shortcuts/b19339f8bfb0409a8ddc2239ef77cd44',
        alert: 'https://www.icloud.com/shortcuts/fcb23eed2a5a4ce297ff57b59f392842'
    },
    {
        label: 'UK 🇬🇧',
        notification: 'https://www.icloud.com/shortcuts/363caf5072544c8f8192cf2e6502a065',
        alert: 'https://www.icloud.com/shortcuts/4b96ac2c3f5942c8aef64868fd9c4774'
    },
    {
        label: 'Germany 🇩🇪',
        notification: 'https://www.icloud.com/shortcuts/be5795fa3a0f4249a61c8160c2809d21',
        alert: 'https://www.icloud.com/shortcuts/da75ead425904a9d96470594bca686e5'
    },
    {
        label: 'China 🇨🇳',
        notification: 'https://www.icloud.com/shortcuts/71dec4c16d984e7bb4758a45dcbbbb28',
        alert: 'https://www.icloud.com/shortcuts/d3091e13d7804153852720f3854c6526'
    },
    {
        label: 'Portugal 🇵🇹',
        notification: 'https://www.icloud.com/shortcuts/c0fb6f32ebc1480b8f1d9537c7c0cd11',
        alert: 'https://www.icloud.com/shortcuts/7b20f3dc57414e5684e21546a2be54e8'
    },
    {
        label: 'Canada 🇨🇦',
        notification: 'https://www.icloud.com/shortcuts/345b0b6e3fe34a279089ec81b6a0f86e',
        alert: 'https://www.icloud.com/shortcuts/ce3403962e5441caba5415f9e7e755bb'
    },
    {
        label: 'Austria 🇦🇹',
        notification: 'https://www.icloud.com/shortcuts/17caed92c1da461c8fbe93c1cec2d2f2',
        alert: 'https://www.icloud.com/shortcuts/45ccc4c6498e4350a2854d2962af9de0'
    },
    {
        label: 'Ireland 🇮🇪',
        notification: 'https://www.icloud.com/shortcuts/521e6a81d1f4412fa9cdbf8c093dc3e2',
        alert: 'https://www.icloud.com/shortcuts/2364a2a596fd4cb49f75f9d8540a9eb0'
    },
    {
        label: 'India 🇮🇳',
        notification: 'https://www.icloud.com/shortcuts/4a89fba0691a449f95f061b578914165',
        alert: 'https://www.icloud.com/shortcuts/5374930a3cf74923aeaa1dc0174a77f1'
    },
    {
        label: 'Israel 🇮🇱',
        notification: 'https://www.icloud.com/shortcuts/b82af62053c243ef97fa0856765ff4d1',
        alert: 'https://www.icloud.com/shortcuts/870537539e214295822772c5ed10f72b'
    },
    {
        label: 'Australia 🇦🇺',
        notification: 'https://www.icloud.com/shortcuts/a0cb7915370540139b04d749bc138e68',
        alert: 'https://www.icloud.com/shortcuts/411539a6842e467794770242f8d3f914'
    },
    {
        label: 'Czech Republic 🇨🇿',
        notification: 'https://www.icloud.com/shortcuts/892b7cabacf8475a938952dac3ab1fb4',
        alert: 'https://www.icloud.com/shortcuts/462da7a4d7594e5c806a6de107198125'
    },
    {
        label: 'Egypt 🇪🇬',
        notification: 'https://www.icloud.com/shortcuts/52bd8372a82e4effab011c181119e1dc',
        alert: 'https://www.icloud.com/shortcuts/28435974c4fe4d4eb4555fce8cc4c0dd'
    },
    {
        label: 'Netherland 🇳🇱',
        notification: 'https://www.icloud.com/shortcuts/b5f3b4917f1048709f53b8316c06f271',
        alert: 'https://www.icloud.com/shortcuts/f046293a4760444aa7caffa1b97dccbe'
    },
    {
        label: 'Sweden 🇸🇪',
        notification: 'https://www.icloud.com/shortcuts/0018159904534e86ba74e816d9b7de6c',
        alert: 'https://www.icloud.com/shortcuts/b115eb7144e246ed9c77be5710d51ad5'
    },
    {
        label: 'Saudi Arabia 🇸🇦',
        notification: 'https://www.icloud.com/shortcuts/436039f719f24249a29bf0b27f001624',
        alert: 'https://www.icloud.com/shortcuts/6755d3adb50049f9a7bab78f9b3d04ae'
    },
    {
        label: 'South Africa 🇿🇦',
        notification: 'https://www.icloud.com/shortcuts/39b66443593741958842f514eafab3f6',
        alert: 'https://www.icloud.com/shortcuts/88a2ddec075a4faf96e2bbd20c9a7987'
    },
    {
        label: 'Denmark 🇩🇰',
        notification: 'https://www.icloud.com/shortcuts/3fdd128df2074bfab16a02b5c82e5b5e',
        alert: 'https://www.icloud.com/shortcuts/24fbf0b2b4fe474b80fe085f51cdeec9'
    },
    {
        label: 'Universal 💫',
        notification: 'https://www.icloud.com/shortcuts/c0af64a3fc3947b48989013213a6dba6',
        alert: 'https://www.icloud.com/shortcuts/7be2e27b9aad485ab29a1059de1d3b88'
    },
    {
        label: 'World 🌍',
        notification: 'https://www.icloud.com/shortcuts/11935d1567444d6196028f833f205fdd',
        alert: 'https://www.icloud.com/shortcuts/f0cfbc60b53c4d86895a65d2bbe6dec7'
    }
]

export default shortcuts